:host{padding:0 15px;width:350px;overflow-x:auto;overflow-y:scroll;height:100%;scrollbar-gutter:stable}
/*# sourceMappingURL=nav-card-list.component-V66FZ3JE.css.map */
